import { useState } from 'react';
import mapIcon from '../../../../common/images/revamp/icon/map.svg';
import CustomGoogleMap from '../../Map';
import { BottomSheet } from 'react-spring-bottom-sheet';
import { useMemo } from 'react';

const Map = () => {
	const [isShowBottomSheet, setIsShowBottomSheet] = useState(false);

	const handleCloseBottomSheet = () => {
		setIsShowBottomSheet(false);
	};

	const handleClick = async () => {
		setIsShowBottomSheet(true);
	};

	const googleMapProps = useMemo(() => {
		return {
			onClose: handleCloseBottomSheet,
			isFormAddress: false,
		};
	}, []);

	return (
		<>
			<div className='w-full flex justify-end mb-4'>
				<div id='search_address_select_map' onClick={handleClick} className='inline-flex gap-1 items-center py-2 px-1'>
					<img src={mapIcon} alt='map' />
					<span className='text-blue-400 text-xs'>Pilih lewat map</span>
				</div>
			</div>
			<BottomSheet key={'select-location-on-map'} header={null} open={isShowBottomSheet} onDismiss={handleCloseBottomSheet}>
				<CustomGoogleMap {...googleMapProps} />
			</BottomSheet>
		</>
	);
};

export default Map;
